export default {
    dependencies: ['$element', 'finnboxservice'],
    callable(ele, finnboxservice) {
        function formatCountDisplay(count) {
            return count > 99 ? '99+' : String(count);
        }

        const notificationEle = ele.querySelector(
            '[data-new-notifications-count]'
        );
        if (notificationEle) {
            finnboxservice.getNumberOfUnreadMessages().then(count => {
                ele.setAttribute(
                    'aria-label',
                    `Min FINN – ${count === 1
                        ? '1 ny melding'
                        : `${count} nye meldinger`}`
                );
                notificationEle.textContent = formatCountDisplay(count);
                notificationEle.classList.toggle('hidden', count === 0);
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxunreadcount.js